import Container from "../../components/Container/Container";
import Layout from "../../components/Layout/Layout";
import ErrorList from "./ErrorList";

export default function PTaskError() {
  return (
    <>
      <Layout />
      <Container>
        <h2>PTask Errors</h2>
        <ErrorList />
      </Container>
    </>
  );
}
